__webpack_require__.p = "/OX-game/";